import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tab-datos-proyecto',
  templateUrl: './tab-datos-proyecto.component.html',
  styleUrls: ['./tab-datos-proyecto.component.css']
})
export class TabDatosProyectoComponent implements OnInit {

  constructor() {
    const datos = JSON.parse(localStorage.getItem('detalle'));

   }

  ngOnInit() {
    const datos = JSON.parse(localStorage.getItem('detalle'));
  }

}
